<form class="grid-container grid-3" [formGroup]="formGroup">
    <ui-form-field class="grid-span-3" [label]="'TAILORED_WIDGET.BUSINESS_INTELLIGENCE.CONFIGURATION.LINES' | translate">
        <ui-selectable-chips
            labelField="name"
            formControlName="linesDimensions"
            groupField="resourceTypeLabel"
            [isDeletable]="true"
            [options]="lineAvailableDimensions$ | async"
        >
            <ng-template let-option="option">{{ option.name }}</ng-template>
        </ui-selectable-chips>
    </ui-form-field>
    <ui-form-field class="grid-row-2" [label]="'TAILORED_WIDGET.BUSINESS_INTELLIGENCE.CONFIGURATION.PIVOT' | translate">
        <ui-select
            formControlName="pivotDimensionCode"
            labelField="name"
            valueField="dimensionCode"
            groupField="resourceTypeLabel"
            [options]="pivotAvailableDimensions$ | async"
            [required]="true"
            [disabled]="!(pivotAvailableDimensions$ | async)?.length || disabled"
        />
    </ui-form-field>
    @if (isPivotTemporalDimension$ | async) {
        <ui-form-field class="grid-row-2" [label]="'TAILORED_WIDGET.BUSINESS_INTELLIGENCE.CONFIGURATION.STEP' | translate">
            <ui-select
                formControlName="pivotStepCode"
                labelField="label"
                valueField="value"
                [options]="stepList"
                [required]="true"
                [disabled]="!stepList?.length || disabled"
                [sortFn]="doNotSort"
            />
        </ui-form-field>
    }

    <ui-form-field class="grid-row-3" [label]="'TAILORED_WIDGET.BUSINESS_INTELLIGENCE.CONFIGURATION.VALUE' | translate">
        <ui-select
            formControlName="measureCode"
            labelField="name"
            valueField="measureCode"
            groupField="resourceTypeLabel"
            [options]="availableMeasures"
            [required]="true"
            [disabled]="!availableMeasures?.length || disabled"
        />
    </ui-form-field>
</form>
